import React from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Typography, makeStyles, Icon } from '@material-ui/core';
import PropTypes from 'prop-types';
import { InfoOutlined, LocationOn } from '@material-ui/icons';
import { useTheme } from '@material-ui/core/styles';
import { convertDateToPST } from '../../../helpers/audit-trail';

const EventTourVenueDetails = props => {
  const theme = useTheme();
  const useStyles = makeStyles({
    eventTour: {
      display: 'flex',
      padding: '10px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    eventTourClose: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '10px',
    },
    divider: {
      paddingTop: '0px !important',
    },
    normalLabel: {
      color: '#494949',
    },
    normalLabelDark: {
      color: '#E9E9E9',
    },
    selectedLabel: {
      color: '#5E176A',
      fontWeight: '600',
    },
    normalContainer: {
      margin: '0px 5px 5px 5px !important',
      '&:hover': {
        backgroundColor: '#E9E9E98C',
        cursor: 'pointer',
      },
      paddingTop: '5px',
      borderRadius: '5px',
    },
    normalContainerDark: {
      margin: '0px 5px 5px 5px !important',
      '&:hover': {
        backgroundColor: '#515151',
        cursor: 'pointer',
      },
      paddingTop: '5px',
      borderRadius: '5px',
    },
    selectedContainer: {
      margin: '0px 5px 5px 5px !important',
      backgroundColor: '#F6EBF8',
      borderRadius: '5px',
    },
    selectedContainerDark: {
      margin: '0px 5px 5px 5px !important',
      backgroundColor: '#D1B9D6',
      borderRadius: '5px',
    },
    infoIcon: {
      color: '#9C27B0',
    },
    infoIconDark: {
      color: '#E1BEE7',
    },
  });
  const { item, selected, noEvents } = props;

  const classes = useStyles();
  const history = useHistory();
  const eventDate = item ? convertDateToPST(item.event_datetime, true) : new Date().toLocaleDateString('en-US');

  const handleRedirection = event => {
    if (!selected) {
      history.push(`/event/pricing/${event.event_id}`);
    }
  };

  const labelClass = () => {
    const normal = theme.palette.type === 'light' ? classes.normalLabel : classes.normalLabelDark;
    return selected ? classes.selectedLabel : normal;
  };

  const containerClass = () => {
    const normalGrid = theme.palette.type === 'light' ? classes.normalContainer : classes.normalContainerDark;
    const selectedGrid = theme.palette.type === 'light' ? classes.selectedContainer : classes.selectedContainerDark;
    return selected ? selectedGrid : normalGrid;
  };

  if (noEvents) {
    return (
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={2}>
            <Icon>
              <InfoOutlined className={theme.palette.type === 'light' ? classes.infoIcon : classes.infoIconDark} />
            </Icon>
          </Grid>
          <Grid item xs={10}>
            <Typography className={labelClass()}>There are no more events for this performer</Typography>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} className={containerClass()} onClick={() => handleRedirection(item)}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography className={labelClass()}>{eventDate}</Typography>
        </Grid>
        <Grid item xs={1} style={{ marginTop: '-5px' }}>
          <Icon>
            <LocationOn style={{ fontSize: '14px' }} className={labelClass()} />
          </Icon>
        </Grid>
        <Grid item xs={11}>
          <Typography className={labelClass()}>{item.venue}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

EventTourVenueDetails.defaultProps = {
  noEvents: null,
};

EventTourVenueDetails.propTypes = {
  item: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  noEvents: PropTypes.bool,
};

export default EventTourVenueDetails;
